import { render, staticRenderFns } from "./OrderPriceLimitSettings.vue?vue&type=template&id=799bb848&scoped=true&"
import script from "./OrderPriceLimitSettings.vue?vue&type=script&lang=js&"
export * from "./OrderPriceLimitSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrderPriceLimitSettings.vue?vue&type=style&index=0&id=799bb848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799bb848",
  null
  
)

export default component.exports